import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=134f379b&scoped=true&"
import script from "./AddBlog.vue?vue&type=script&lang=js&"
export * from "./AddBlog.vue?vue&type=script&lang=js&"
import style0 from "./AddBlog.vue?vue&type=style&index=0&id=134f379b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f379b",
  null
  
)

export default component.exports